import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { memo } from 'react';
import { ErrorBoundary } from 'shared/components/error-boundary';
export const SettingContainer = memo(function SettingContainer(props) {
    const { children, ...rest } = props;
    return (_jsx(ErrorBoundary, { children: _jsx(Box, { display: "grid", gridTemplateRows: "repeat(auto-fill, minmax(35px, 1fr))", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: 2, boxSizing: "border-box", width: "100%", ...rest, children: children }) }));
});
